import React, { useState } from "react";
import { Form, Button, Alert } from 'react-bootstrap';
import '../asset/css/index.css';
import { baseUrl } from "../utils/config";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError("");
        setMessage("");
        try {
            const response = await fetch(`${baseUrl}/app_api/v1/user/forgotPassword?email=${encodeURIComponent(email)}`, {
                method: "POST"
            });

            if (response.ok) {
                setSuccess(true);
            } else if (response.status === 406) {
                setError("Votre compte est désactivé, veuillez contacter votre administrateur.");
            } else {
                setError("Une erreur est survenu, veuillez contacter votre administrateur.");
            }
        } catch (error) {
            setError("Erreur lors de l'envoi de l'e-mail de reinitialisation.")
        }
    }

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-left">
                    <h1>BACK-OFFICE TECHSITE</h1>
                    <p>Administration de l’application techsite</p>
                    <div className="login-illustration-forgot" />
                </div>
                <div className="login-right">
                    {success ? (
                        <>
                            <div className="text-center mt-3">
                                L'e-mail de réinitialisation du mot de passe a été envoyé avec succès. Veuillez consulter votre boîte de réception pour suivre les instructions.
                            </div>
                            <div className="text-center mt-3">
                                <Link to="/login" className="login-forgot"><FaArrowLeft /> Retour à la connexion</Link>
                            </div>
                        </>
                    ) : (<div className="login-form-container">
                        <h2 className="login-title">Mot de passe oublié</h2>
                        {message && <Alert variant="success">{message}</Alert>}
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Control
                                    type="email"
                                    placeholder="Adresse e-mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Button variant="primary" type="submit" className="w-100">
                                Envoyer l'e-mail de réinitilisation
                            </Button>
                        </Form>
                        <div className="text-center mt-3">
                            <Link to="/login" className="login-forgot"><FaArrowLeft /> Retour à la connexion</Link>
                        </div>
                    </div>)
                    }
                </div>
            </div>
        </div>
    );

};

export default ForgotPassword;